import { MAIN_ROOM_ID } from './constants';
export const createParticipants = () => {
    const participants = new Map([
        [MAIN_ROOM_ID, new Map()],
    ]);
    function get(roomID, uuid) {
        if (!uuid) {
            return participants.get(roomID);
        }
        return participants.get(roomID)?.get(uuid);
    }
    const set = (roomID, participant) => {
        if (!participant) {
            participants.set(roomID, new Map());
            return;
        }
        const roomParticipants = participants.get(roomID);
        if (roomParticipants) {
            roomParticipants.set(participant.uuid, participant);
        }
        else {
            participants.set(roomID, new Map([[participant.uuid, participant]]));
        }
    };
    const find = (roomId, predicate) => {
        const roomParticipants = participants.get(roomId);
        if (!roomParticipants) {
            return undefined;
        }
        for (const p of roomParticipants.values()) {
            if (predicate(p)) {
                return p;
            }
        }
        return undefined;
    };
    const remove = (roomID, uuid) => {
        if (uuid) {
            return participants.get(roomID)?.delete(uuid);
        }
        return participants.delete(roomID);
    };
    const getAll = (roomID) => {
        const list = participants.get(roomID);
        if (!list) {
            return [];
        }
        return Array.from(list.values());
    };
    return {
        get,
        set,
        get size() {
            return participants.size;
        },
        find,
        remove,
        getAll,
    };
};
//# sourceMappingURL=participants.js.map